<template>
  <section class="section portfolio glow-bg">
    <h2 class="section-title">精选案例</h2>
    <div class="portfolio-grid">
      <div class="card portfolio-card" v-for="(item, index) in cases" :key="index">
        <div class="image-wrapper">
          <img :src="item.image" :alt="item.title" loading="lazy" />
          <div class="overlay">
            <span class="view-btn">查看详情</span>
          </div>
        </div>
        <div class="card-content">
          <span class="category">{{ item.category }}</span>
          <h3 class="title">{{ item.title }}</h3>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PortfolioSection',
  data() {
    return {
      cases: [
        {
          title: '企业级 SaaS 管理控制台',
          category: 'Web 开发',
          image: 'https://coresg-normal.trae.ai/api/ide/v1/text_to_image?prompt=A%20modern%20SaaS%20dashboard%20UI%20with%20charts%20and%20graphs%2C%20flat%20design%2C%20light%20theme%2C%20dribbble%20style&image_size=landscape_16_9'
        },
        {
          title: '智能家居物联小程序',
          category: '小程序',
          image: 'https://coresg-normal.trae.ai/api/ide/v1/text_to_image?prompt=A%20smart%20home%20mobile%20app%20UI%20design%20with%20glassmorphism%2C%20modern%20clean%2C%20soft%20colors&image_size=landscape_16_9'
        },
        {
          title: '高转化率品牌落地页',
          category: 'UI/UX 设计',
          image: 'https://coresg-normal.trae.ai/api/ide/v1/text_to_image?prompt=A%20creative%20and%20modern%20landing%20page%20for%20a%20tech%20startup%2C%203D%20elements%2C%20vibrant%20gradients&image_size=landscape_16_9'
        },
        {
          title: '跨境电商独立站',
          category: '全栈开发',
          image: 'https://coresg-normal.trae.ai/api/ide/v1/text_to_image?prompt=A%20minimalist%20e-commerce%20website%20showing%20fashion%20products%2C%20clean%20white%20background%2C%20high%20end&image_size=landscape_16_9'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.portfolio-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
}

.portfolio-card {
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  &:hover {
    .image-wrapper img {
      transform: scale(1.05);
    }
    .overlay {
      opacity: 1;
    }
  }
}

.image-wrapper {
  position: relative;
  width: 100%;
  height: 220px;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(30, 41, 59, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity var(--transition-speed) ease;
  backdrop-filter: blur(2px);
}

.view-btn {
  background: white;
  color: var(--text-primary);
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  transform: translateY(10px);
  transition: transform var(--transition-speed) ease;
}

.portfolio-card:hover .view-btn {
  transform: translateY(0);
}

.card-content {
  padding: 24px;
}

.category {
  font-size: 12px;
  color: var(--primary-color);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 8px;
  display: block;
}

.title {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}
</style>
